import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import React, { useCallback, useState } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { Page } from './App';
import { userWithDefault, User } from '../types/user';
import { Root, Message, Explanation, Hr, H3 } from './common/styled';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
interface Props {
  turnOnIsAdminFlag: () => void;
  goToPage: (page: Page) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      margin: theme.spacing(2),
    },
    button: {
      margin: theme.spacing(2),
    },
  })
);
export const LoginPage = memoNamed<Props>('LoginPage', (props: Props) => {
  const [loginMessage, setLoginMessage] = useState<string>('');
  const [isLoginLoading, setIsLoginLoading] = useState<boolean>(false);

  const [loginEmail, setLoginEmail] = useState<string>('');
  const [loginPassword, setLoginPassword] = useState<string>('');

  const classes = useStyles();
  const onLoginClick = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      // TODO: login_emailがメールアドレスであるかどうか
      // TODO: login_passwordが英数字x字~y字であるかどうか
      event.preventDefault();
      const db = firebase.firestore();
      // ログイン処理
      setIsLoginLoading(true);
      firebase
        .auth()
        .signInWithEmailAndPassword(loginEmail, loginPassword)
        .then(() => {
          // ユーザーがAdminかどうかを調べ、index.jsのstateのisAdminにTrue or Falseを設定
          const user = firebase.auth().currentUser;
          db.collection('Users')
            .where('userID', '==', user?.uid)
            .get()
            .then((snapshot) => {
              setIsLoginLoading(false);
              if (snapshot.empty) {
                setIsLoginLoading(false);
                setLoginMessage(
                  'アカウントに一致するデータが存在しません。管理者に問い合わせてください。'
                );
              } else if (snapshot.size === 1) {
                const userData: User = userWithDefault(snapshot.docs[0].data());
                if (userData['isAdmin']) {
                  props.turnOnIsAdminFlag();
                }
                props.goToPage('MyPage');
              } else {
                setLoginMessage(
                  `同じ仮ID(${user?.uid})を持ったアカウントが複数(${snapshot.size}存在します。管理者に問い合わせてください。`
                );
              }
            })
            .catch((error) => {
              setIsLoginLoading(false);
              console.error(error);
              setLoginMessage(
                '一般会員/管理者設定の読み込みにおいてエラーが発生しました。再度ログインをやり直しても上手くいかない場合、担当者(togen.meibo@gmail.com)に問い合わせてください。'
              );
            });
        })
        // エラー対応
        .catch((error) => {
          console.error(error);
          setIsLoginLoading(false);
          setLoginMessage('ログインに失敗しました。');
        });
    },
    [props, loginEmail, loginPassword]
  );

  const goToSignUp = useCallback(() => {
    props.goToPage('SignUpPage');
  }, [props]);

  const onChangeLoginEmail = useCallback((event) => {
    setLoginEmail(event.target.value);
  }, []);

  const onChangePassword = useCallback((event) => {
    setLoginPassword(event.target.value);
  }, []);
  return (
    <Root>
      <H3>Togen-Meibo</H3>
      <Hr />
      <Explanation>
        このサイトは東京大学ピアノの会OBOG団体「桃源会」の会員専用サイトです。本サイトに関する質問やご意見などはtogen.meibo@gmail.comまでご連絡ください。
      </Explanation>
      <H3>ログイン</H3>
      <Hr />
      <Explanation>
        ログイン用Emailアドレスとパスワードを入力して、ログインボタンをクリックしてください。
      </Explanation>
      <form onSubmit={onLoginClick}>
        <TextField
          label='Emailアドレス'
          variant='filled'
          type='email'
          value={loginEmail}
          onChange={onChangeLoginEmail}
          className={classes.textField}
        />
        {/* 適切なメールアドレスかチェック */}
        <TextField
          label='パスワード'
          type='password'
          value={loginPassword}
          onChange={onChangePassword}
          variant='filled'
          className={classes.textField}
        />
        {/* 適切なパスワードかチェック */}
        <br />
        <Message>{loginMessage}</Message>
        <Button
          className={classes.button}
          type='submit'
          variant='contained'
          color='primary'
        >
          ログイン
        </Button>
        {isLoginLoading ? ' 通信中...' : ''}
      </form>
      <H3>初めての方</H3>
      <Hr />
      <Button
        className={classes.button}
        variant='contained'
        color='secondary'
        onClick={goToSignUp}
      >
        初めての方はこちら
      </Button>
    </Root>
  );
});
